/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull browser'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 1
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/implementation/browser)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'cmswebstaging';

export const ApiKey: Record<Environment, string> = {
  cmswebstaging: '',
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '1',
    branch: 'main',
    source: 'browser',
    versionId: '0ce80406-349a-414c-a78c-a2337c1e20f0',
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0',
    },
  },
};

export interface LoadOptionsBase {
  disabled?: boolean;
}

export type LoadOptionsWithEnvironment = LoadOptionsBase & {
  environment: Environment;
  client?: { configuration?: BrowserOptions };
};
export type LoadOptionsWithApiKey = LoadOptionsBase & {
  client: { apiKey: string; configuration?: BrowserOptions };
};
export type LoadOptionsWithClientInstance = LoadOptionsBase & {
  client: { instance: BrowserClient };
};

export type LoadOptions =
  | LoadOptionsWithEnvironment
  | LoadOptionsWithApiKey
  | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  'app used'?: string;
  'is enerlink'?: boolean;
  'is staff'?: boolean;
}

export interface SetAsHomePageButtonClickedProperties {
  'selected home page': string;
}

export interface LoggedInProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | active session, login screen |
   */
  'login method': 'active session' | 'login screen';
}

export interface OnboardingModalViewedProperties {
  'onboarding screen path': string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | button, automatic |
   */
  'onboarding type': 'button' | 'automatic';
}

export interface SupportChatOpenedProperties {
  'support chat source screen': string;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(public event_properties?: IdentifyProperties) {
    this.event_properties = event_properties;
  }
}

export class SetAsHomePageButtonClicked implements BaseEvent {
  event_type = '"set as home page" button clicked';

  constructor(public event_properties: SetAsHomePageButtonClickedProperties) {
    this.event_properties = event_properties;
  }
}

export class AnalyticsDetailExcelDownloaded implements BaseEvent {
  event_type = 'analytics detail excel downloaded';
}

export class ChargePointStatusOpened implements BaseEvent {
  event_type = 'charge point status opened';
}

export class ChargeStartButtonClicked implements BaseEvent {
  event_type = 'charge start button clicked';
}

export class ConnectorSelected implements BaseEvent {
  event_type = 'connector selected';
}

export class EditChargeProfileClicked implements BaseEvent {
  event_type = 'edit charge profile clicked';
}

export class FleetMapLoaded implements BaseEvent {
  event_type = 'fleet map loaded';
}

export class FleetSummaryViewed implements BaseEvent {
  event_type = 'fleet summary viewed';
}

export class FleetTripExcelDownloaded implements BaseEvent {
  event_type = 'fleet trip excel downloaded';
}

export class FullScreenModeClicked implements BaseEvent {
  event_type = 'full screen mode clicked';
}

export class LoggedIn implements BaseEvent {
  event_type = 'logged in';

  constructor(public event_properties: LoggedInProperties) {
    this.event_properties = event_properties;
  }
}

export class NotificationsBellSelected implements BaseEvent {
  event_type = 'notifications bell selected';
}

export class NotificationsEdited implements BaseEvent {
  event_type = 'notifications edited';
}

export class OnboardingModalViewed implements BaseEvent {
  event_type = 'onboarding modal viewed';

  constructor(public event_properties: OnboardingModalViewedProperties) {
    this.event_properties = event_properties;
  }
}

export class SalesChargesExcelDownloaded implements BaseEvent {
  event_type = 'sales-charges excel downloaded';
}

export class SalesPaymentExcelDownloaded implements BaseEvent {
  event_type = 'sales-payment excel downloaded';
}

export class SupportChatOpened implements BaseEvent {
  event_type = 'support chat opened';

  constructor(public event_properties: SupportChatOpenedProperties) {
    this.event_properties = event_properties;
  }
}

export class Test implements BaseEvent {
  event_type = 'test';
}

export class TransactionExcelDownloadClicked implements BaseEvent {
  event_type = 'transaction excel download clicked';
}

export class TransactionListExcelDownloadClicked implements BaseEvent {
  event_type = 'transaction list excel download clicked';
}

export class UpdateConnectorsClicked implements BaseEvent {
  event_type = 'update connectors clicked';
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * "set as home page" button clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/%22set%20as%20home%20page%22%20button%20clicked)
   *
   * Cuando el usuario clickea el botón para establecer la página como principal.
   *
   * @param properties The event's properties (e.g. selected home page)
   * @param options Amplitude event options.
   */
  setAsHomePageButtonClicked(
    properties: SetAsHomePageButtonClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SetAsHomePageButtonClicked(properties), options);
  }

  /**
   * analytics detail excel downloaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/analytics%20detail%20excel%20downloaded)
   *
   * Cuando el usuario clickea el botón "Descargar detalle en excel" en /analytics.
   *
   * @param options Amplitude event options.
   */
  analyticsDetailExcelDownloaded(
    options?: EventOptions,
  ) {
    return this.track(new AnalyticsDetailExcelDownloaded(), options);
  }

  /**
   * charge point status opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/charge%20point%20status%20opened)
   *
   * Cuando el usuario clickea el botón "Tiempo de actividad del cargador" en /charge-center/all/grid-connections/charge-points
   *
   * @param options Amplitude event options.
   */
  chargePointStatusOpened(
    options?: EventOptions,
  ) {
    return this.track(new ChargePointStatusOpened(), options);
  }

  /**
   * charge start button clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/charge%20start%20button%20clicked)
   *
   * Cuando el usuario hace clic en el botón "Iniciar carga" desde un conector específico.
   *
   * @param options Amplitude event options.
   */
  chargeStartButtonClicked(
    options?: EventOptions,
  ) {
    return this.track(new ChargeStartButtonClicked(), options);
  }

  /**
   * connector selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/connector%20selected)
   *
   * Cuando el usuario ve la sidebar de un conector específico, ya sea en /charge-center/all/grid-connections/connectors o /charge-center/all/grid-connections/charge-points
   *
   * @param options Amplitude event options.
   */
  connectorSelected(
    options?: EventOptions,
  ) {
    return this.track(new ConnectorSelected(), options);
  }

  /**
   * edit charge profile clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/edit%20charge%20profile%20clicked)
   *
   * Cuando el usuario clickea el botón "editar perfil" en "Perfiles de carga" .
   *
   * @param options Amplitude event options.
   */
  editChargeProfileClicked(
    options?: EventOptions,
  ) {
    return this.track(new EditChargeProfileClicked(), options);
  }

  /**
   * fleet map loaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/fleet%20map%20loaded)
   *
   * Cuando se visualiza el mapa de la flota de /fleet, incluyendo cambios de tab.
   *
   * @param options Amplitude event options.
   */
  fleetMapLoaded(
    options?: EventOptions,
  ) {
    return this.track(new FleetMapLoaded(), options);
  }

  /**
   * fleet summary viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/fleet%20summary%20viewed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  fleetSummaryViewed(
    options?: EventOptions,
  ) {
    return this.track(new FleetSummaryViewed(), options);
  }

  /**
   * fleet trip excel downloaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/fleet%20trip%20excel%20downloaded)
   *
   * Cuando el usuario clickea el botón "Descargar excel" en /admin/fleet-trip-history/.
   *
   * @param options Amplitude event options.
   */
  fleetTripExcelDownloaded(
    options?: EventOptions,
  ) {
    return this.track(new FleetTripExcelDownloaded(), options);
  }

  /**
   * full screen mode clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/full%20screen%20mode%20clicked)
   *
   * Cuando el usuario clickea el componente para activar "pantalla completa".
   *
   * @param options Amplitude event options.
   */
  fullScreenModeClicked(
    options?: EventOptions,
  ) {
    return this.track(new FullScreenModeClicked(), options);
  }

  /**
   * logged in
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/logged%20in)
   *
   * Cuando el usuario accede al contenido de la plataforma, ya sea desde la pantalla de login o con la sesión guardada
   *
   * @param properties The event's properties (e.g. login method)
   * @param options Amplitude event options.
   */
  loggedIn(
    properties: LoggedInProperties,
    options?: EventOptions,
  ) {
    return this.track(new LoggedIn(properties), options);
  }

  /**
   * notifications bell selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/notifications%20bell%20selected)
   *
   * Cuando el usuario hace click en la campana de notificaciones.
   *
   * @param options Amplitude event options.
   */
  notificationsBellSelected(
    options?: EventOptions,
  ) {
    return this.track(new NotificationsBellSelected(), options);
  }

  /**
   * notifications edited
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/notifications%20edited)
   *
   * Cuando el usuario activa o desactiva algún tipo de notificación en "preferencias"
   *
   * @param options Amplitude event options.
   */
  notificationsEdited(
    options?: EventOptions,
  ) {
    return this.track(new NotificationsEdited(), options);
  }

  /**
   * onboarding modal viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/onboarding%20modal%20viewed)
   *
   * Cuando el usuario visualiza uno de los modales de onboarding, ya sea disparado automáticamente o de manera activa.
   *
   * @param properties The event's properties (e.g. onboarding screen path)
   * @param options Amplitude event options.
   */
  onboardingModalViewed(
    properties: OnboardingModalViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new OnboardingModalViewed(properties), options);
  }

  /**
   * sales-charges excel downloaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/sales-charges%20excel%20downloaded)
   *
   * Cuando el usuario clickea el botón "Descargar excel" en /sales/charges.
   *
   * @param options Amplitude event options.
   */
  salesChargesExcelDownloaded(
    options?: EventOptions,
  ) {
    return this.track(new SalesChargesExcelDownloaded(), options);
  }

  /**
   * sales-payment excel downloaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/sales-payment%20excel%20downloaded)
   *
   * Cuando el usuario clickea el botón "Descargar excel" en /sales/payments
   *
   * @param options Amplitude event options.
   */
  salesPaymentExcelDownloaded(
    options?: EventOptions,
  ) {
    return this.track(new SalesPaymentExcelDownloaded(), options);
  }

  /**
   * support chat opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/support%20chat%20opened)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. support chat source screen)
   * @param options Amplitude event options.
   */
  supportChatOpened(
    properties: SupportChatOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SupportChatOpened(properties), options);
  }

  /**
   * test
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/test)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  test(
    options?: EventOptions,
  ) {
    return this.track(new Test(), options);
  }

  /**
   * transaction excel download clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/transaction%20excel%20download%20clicked)
   *
   * Cuando el usuario clickea el botón "Descargar" en una transacción en /charge-center/assets-transactions
   *
   * @param options Amplitude event options.
   */
  transactionExcelDownloadClicked(
    options?: EventOptions,
  ) {
    return this.track(new TransactionExcelDownloadClicked(), options);
  }

  /**
   * transaction list excel download clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/transaction%20list%20excel%20download%20clicked)
   *
   * Cuando el usuario clickea el botón "Descargar excel" en la lista de transacciones en /charge-center/assets-transactions
   *
   * @param options Amplitude event options.
   */
  transactionListExcelDownloadClicked(
    options?: EventOptions,
  ) {
    return this.track(new TransactionListExcelDownloadClicked(), options);
  }

  /**
   * update connectors clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/enerlink/CMS%20web%20(staging)/events/main/latest/update%20connectors%20clicked)
   *
   * Cuando el usuario clickea el botón "Actualizar conectores" en /charge-center/all/grid-connections/charge-points.
   *
   * @param options Amplitude event options.
   */
  updateConnectorsClicked(
    options?: EventOptions,
  ) {
    return this.track(new UpdateConnectorsClicked(), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
